import styled from 'styled-components'

export const ChartsContainer = styled.div`
  position: relative;
  display: flex;
  gap: ${props => props.theme.spacing.sp40};
  margin-top: ${props => props.theme.spacing.sp32};
  margin-bottom: -64px;
`

export const ChartContainer = styled.div`
  width: 100%;
  height: 230px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: ${props => props.theme.spacing.sp16};
`

export const ModalTitle = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
`
